import { InfoPopoverProps, Stack } from '@landler/component-library';

import { R1FactType } from '@/api/rest/resources/types/fact';
import { GraphTypeValue } from '@/components/Charts/hooks/useChartType';
import { CompositeGraph, CompositeGraphProps } from '@/components/widgets/o/CompositeGraph/CompositeGraph';
import { useOrganizationIndicatorGraphFact } from '@/pages/shared/hooks/useOrganizationFact';

import { ChartHeading } from '../Charts/components/ChartHeading';
import { ChartZoomStateHook } from '../Charts/components/ChartZoom';
import { NUM_ITEMS_TYPE } from '../Charts/hooks/usePlotsForItemizedGraph';
import { GraphFact } from '../Charts/types';

export type GraphTileProps = {
  headerProps: GraphTileHeaderProps;
  contentProps: GraphTileContentProps;
  zoom?: ChartZoomStateHook['zoom'];
  setZoom?: ChartZoomStateHook['setZoom'];
  plotGroupId?: string | null;
  showEmpty?: boolean;
  graphType?: GraphTypeValue;
  plotRenderType?: (typeof NUM_ITEMS_TYPE)[keyof typeof NUM_ITEMS_TYPE];
};

type GraphTileHeaderProps = {
  title: string;
  popoverProps?: Partial<InfoPopoverProps>;
  hideChartHeader?: boolean;
};

type GraphTileContentProps = { graphFactType?: R1FactType | null } & CompositeGraphProps;

export const GraphTile = ({ headerProps, contentProps, plotGroupId }: GraphTileProps) => {
  const fact = contentProps.graphFactType ?? R1FactType.unknown;
  const { [fact]: graphFact } = useOrganizationIndicatorGraphFact<GraphFact[]>(
    contentProps.graphFactType ?? R1FactType.unknown,
    null,
    undefined,
    plotGroupId,
  );
  const graphData = graphFact?.value;

  return (
    <Stack center>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        {headerProps && <ChartHeading {...headerProps} heading={headerProps.title} className='w-full px-6 sm:px-0' />}
        {contentProps && <CompositeGraph {...contentProps} data={graphData?.length ? graphData : contentProps.data} />}
      </Stack>
    </Stack>
  );
};
